import styled from 'styled-components'

export const BcContainer = styled.div`
  display: flex;
  margin-bottom: ${({ mb }) => (mb ? mb : 0)};
`

export const BcLeft = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`

export const BcRight = styled.div`
  flex: 1;
`

export const BcBottomBar = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
`
